import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiMode } from '../../../utils';
import { ApiService, DataService, LanguageService, OfflineApiService } from '../../../shared/services';
import { OptmizationMachineSelectorPluginService } from '../../optimisationmachineselector/optimizationmachineselector-plugin.service';
import { InstallationEquipmentInfoPluginFactoryService } from './equipment-info-plugin-factory.service';
import { AppConstants } from '../../../utils/appConstants.class';

@Injectable()
export class InstallationEquipmentInfoPluginService extends OptmizationMachineSelectorPluginService {
  supplierTypeKeys: any = [
    { value: 1, label: 'plugins.installation-equipment-info.bobst' },
    { value: 2, label: 'plugins.installation-equipment-info.customer' }
  ];

  suppliers = [];

  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    offlineApi: OfflineApiService,
    protected factory: InstallationEquipmentInfoPluginFactoryService,
    private language: LanguageService
  ) {
    super(apiService, dataService, offlineApi, factory);
    this.applyTranslations();
    this.language.onLanguageChange().subscribe(() => this.applyTranslations());
  }

  getModels(): Observable<any> {
    const url = '/plugins/instmachineselector/models';
    return this.offlineApi.getWithMode(url, ApiMode.Offline, AppConstants.INDEXEDDB_TABLES.models);
  }

  getSuppliers() {
    return this.suppliers;
  }

  applyTranslations() {
    this.suppliers = [];
    this.copyTranslationValues(this.supplierTypeKeys, this.suppliers, this.language);
  }
}
